import React from 'react';
import Banner from '../components/catalog/banner';
import Cat from '../components/catalog/cat'; 
import './catalog.css'; 

const Catalog = () => {
  return (
    <div className="catalog-page">
      <Banner />
      <div className="catalog-content">
        <Cat /> {/* Вставляем компонент Cat здесь */}
      </div>
    </div>
  );
};

export default Catalog;
